import * as React from 'react';

interface IProps {
    onChange?: any;
}

interface IState {
    value: string;
}

class NotificationContext extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            value: '{\n' +
                '   "cartUrl":"https://pharmacy.integ.amazon.com/cart/cartPage",\n' +
                '   "dashboardUrl":"https://pharmacy.integ.amazon.com/dashboard",\n' +
                '   "shortDrugName":"testShortDrugName",\n' +
                '   "drugName":"testDrugName",\n' +
                '   "dose":"testDose",\n' +
                '   "pharmacyLink":"https://pharmacy.integ.amazon.com/",\n' +
                '   "commsCategory":"testCommsCategory",\n' +
                '   "helpUrl":"https://pharmacy.integ.amazon.com",\n' +
                '   "medication":"testMedication",\n' +
                '   "obfuscatedDrugName":"testObfuscatedDrugName",\n' +
                '   "chaseFromPharmacy":"testChaseFromPharmacy",\n' +
                '   "prescriberName":"testPrescriberName",\n' +
                '   "prescriberPhoneNumber":"1111111111",\n' +
                '   "transferFromPharmacyName":"testTransferFromPharmacyName",\n' +
                '   "transferFromPharmacyPhoneNumber":"1111111111",\n' +
                '   "rxId":"testRxId",\n' +
                '   "signupUrl":"https://pharmacy.integ.amazon.com",\n' +
                '   "drugQuantity":"1",\n' +
                '   "orderId":"111-1111111-1111111",\n' +
                '   "promiseDate":"02-06-2020",\n' +
                '   "state":"WA",\n' +
                '   "city":"Seattle",\n' +
                '   "orderTotal":"500",\n' +
                '   "pharmacyYourOrderUrl":"https://pharmacy.integ.amazon.com",\n' +
                '   "previousPharmacyName":"testPreviousPharmacyName",\n' +
                '   "previousPharmacyPhoneNumber":"2222222222",\n' +
                '   "preShortDrugName":"testPreShortDrugName",\n' +
                '   "preDrugName":"testPreDrugName",\n' +
                '   "preDrugQuantity":"1",\n' +
                '   "newShippingDate":"02-07-2020",\n' +
                '   "shippingDate":"02-06-2020",\n' +
                '   "orderDate":"02-05-2020",\n' +
                '   "customerCareLink":"https://pharmacy.integ.amazon.com",\n' +
                '   "brand":"testBrand",\n' +
                '   "tail":"testTail",\n' +
                '   "bodyContent":"testBodyContent",\n' +
                '   "trackingLink":"https://pharmacy.integ.amazon.com",\n' +
                '   "itemCount":"2",\n' +
                '   "quantity":"1"\n' +
                '}',
        }

        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        return (
            <div>
                <textarea name='content' rows={39}
                          cols={55}
                          onChange={this.handleChange}
                          value={this.state.value}
                />
            </div>
        )
    }

    public getState() {
        return this.state;
    }

    private handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({value: event.target.value})
    }

}

export default NotificationContext
